import React from 'react';
import './App.scss';
import Daimler from './scenes/Daimler/Daimler';


function App() {
  return (
    <div className="App">
      <Daimler/>
    </div>
  );
}

export default App;
